module.exports = __webpack_public_path__ + "img/4c5a307.png";